import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I give up, Apple will never understand dual screen as well as Linux",
  "description": "",
  "published": "2013-10-24T00:00:00.000Z",
  "redirect_from": ["/blog/i-give-up-apple-will-never-understand-dual-screen-as-well-as-linux/swizec/6387"],
  "categories": "Apple, Linux, Mission Control, Multi-monitor, Uncategorized, Windows, Xinerama",
  "hero": "./img/images-2949.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ea089cd0053bfb013babe9ea3fabbad5/41099/images-2949.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M278%2019l-3%2061v20h-52l-68-1h-16v-4c0-4%200-4-3-4l-16-1c0-2%201-2%204-2l4%201h10l1-8-1-17v-9h-5c-7%200-6-2%200-2h6l-6-1-50-2c-4%200-4%200-4%203l1%2023c2%2026%201%2024%208%2023%207%200%2010%201%2010%203l1%202%201-3c-1-2-1-3-6-3-6%200-8-2-3-2%206-1%2015%200%2014%202l1%202%202-2c0-1%200-2%203-2s4%202%201%203c-4%200-3%201%200%201%202%200%203%200%203%202s1%202%2011%202c11%201%2012%200%2010-1-2-2%200-2%206-2%205%200%208%201%205%202v1h2l1-1v-2h5c4%200%207%202%205%203-1%201-1%201%201%201s2%200%201-2c0-2%200-2%206-2%207%201%208%202%203%203l-2%201h3c2%200%203%200%204-2%200-2%207-2%2010-1h1c2-2%205%200%204%202l1%202h3c1%201%201%201-2%201-4-1-5%200-3%201s0%202-3%203l-4-1-1-2v1a660%20660%200%2000-15%204c0%201-3%202-8%202-7-1-7%200-1%201%204%200%207%201%207%202h-4l-6%201%2017%201%204%201-8%201h-10c-2-2-5%200-4%202%200%202%200%202-5%202l-5-1%204-1%203-1-1-1-2-1%202-1%201-1-1-1-2-1%201-1%202-1-1-1-5-1h2l3-1c1-1%201-1-3-1l-2-2c-1-2-5-3-6-1l2%201h2c1%201-3%202-15%201l-16-1%2011-1h11l-2-1a1247%201247%200%2001-22%201c-1%202-2%202-13%202l-13-1%208-1%209-1-8-1H83c1-2%201-2%207-2%205%200%206%200%205-1l-8-1h-5v4l-1%203H0v13c0%2014%200%2014%202%2014l3%201H0v92l3-1%2025-6c30-9%2043-9%2053-2%208%205%209%207%209%2014a2076%202076%200%2000-4%20116c-2%201-6%201-6-1%200-1-13-7-20-9-9-2-34-1-49%202l-10%202-1%2028v28h401l-1-47-1-47a190%20190%200%2000-27%203c-3%200-4%203-2%205v4c-2%201-4-1-4-4-1-3-3-3-30%201a3203%203203%200%2001-238%2029l-3-25-2-29%201-54c1-9%201-10%206-13%209-4%2018-5%2046-5%2031%200%2047-1%2065-4a268%20268%200%200153-5c-6%200-6%200-4%202l5%202c3%200%204%200%204%202v3h2c1-1%201-1%201%201-1%201%200%203%205%207l7%206%2017%2015%2012%2010c3%203%204%203%204%202%200-2%200-2%203%200%202%203%203%204%200%204l-1%201h3c2%200%202%200%201%201s10%2012%2013%2013l15%2013%207%206%208%206%204%202v-3c1%200%201-1-1-2-1-1-1-1%201-1%201%200%202%201%202%203s1%203%203%200h1c0%202%201%202%203%201%201%200%202%200%201%201%200%203%202%203%2012%201l8-2v-15a301%20301%200%20000-16c-1-2-3-3-5-3l-2-2%204-1%203%201%201-65c0-36%200-59-1-51v14h-27l-26-1%204-97c1-5%201-5-13-4h-12v10l-2%2025v15h-3l-4%201h-11l-1%201-2-1h-1v3l-1%201-1-2c-1-2-1-2-1%200%200%203%200%203%205%203l4%201h-5c-4%200-4%200-4%202l-1%206v4h12l11%201v11c0%2020-1%2032-2%2033l-2-1%201-20%201-20h-24l1-8a4002%204002%200%20004-88l50-2h50V26l-29%201c-67%201-76%201-77%203s-1%202-1-15V0h-15v19M88%2085l2%201%202%202c0%202-2%203-2%201-1-2-8-3-8-1%200%201%201%202%203%202%204%200%204%201%200%201l-3%201%204%201%202%201c2%202%204%201%204-2%200-2%200-2%207-1l7-1c0-2-5-3-6-2h-2l-3-1c-2%200-2%200-1-1%204-1%202-2-3-2-2%200-4%200-3%201m256%2082l-1%203v3h11l29%201h17v-3c0-2-1-3-2-3h-21c-2-1-32-2-33-1m-101%2022l-3%202-3-2-2-1h2c3%200%202-2-1-2-2%200-3%201-3%202-1%204-1%204%201%204%203-1%204%200%203%202h-3c-2-1-2-1-2%201s3%203%206%201c4-2%207-2%207-1%201%202%203-1%202-3v-4c0-4-1-4-4%201m-119%2049c0%201%202%204%204%204l1%201h-7l3%202c1%202%207%204%2013%206l10%204%206%201%206%201v1h1c-2%201-1%202%201%202l11%203a294%20294%200%200019%208%20287%20287%200%200043%2014h14l-2-2-2-1h3c3%200%204-1%205-2%201-2%201-2-6-7-5-4-32-14-45-17-4%200-13-3-20-6-43-14-44-14-51-14-4%200-6%201-7%202m138%2092l-8%201-8%201h-7c0%201-9%202-16%201h-2l2%201c2%201-4%202-10%201l-2%201%2022-1%208-1c5%200%207%200%206%201v1c2%200%204-2%202-2l12-3h7l-6-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea089cd0053bfb013babe9ea3fabbad5/ca0a1/images-2949.webp 223w", "/static/ea089cd0053bfb013babe9ea3fabbad5/75680/images-2949.webp 445w", "/static/ea089cd0053bfb013babe9ea3fabbad5/b0a15/images-2949.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea089cd0053bfb013babe9ea3fabbad5/853b2/images-2949.jpg 223w", "/static/ea089cd0053bfb013babe9ea3fabbad5/0a4fe/images-2949.jpg 445w", "/static/ea089cd0053bfb013babe9ea3fabbad5/41099/images-2949.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ea089cd0053bfb013babe9ea3fabbad5/41099/images-2949.jpg",
                "alt": "My workspace with Mountain Lion",
                "title": "My workspace with Mountain Lion",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`My workspace with Mountain Lion`}</figcaption>{`
  `}</figure></p>
    <p><em parentName="p">{`[`}{`Warning: the wallpaper I use has never been a problem in any office I ever visited, but it does feature a human nipple. If you are a prude, please close your eyes when you reach the screenshots instead of bugging me about it. It's just boobs, relax]`}</em></p>
    <p>{`Setting up dual screen for the first was a pain in the arse. I had just unwrapped my first ever 17" `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Flat_panel_display",
        "title": "Flat panel display"
      }}>{`flat screen`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Cathode_ray_tube",
        "title": "Cathode ray tube"
      }}>{`CRT monitor`}</a>{` and noticed my graphics card had two `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Video_Graphics_Array",
        "title": "Video Graphics Array"
      }}>{`VGA`}</a>{` outputs. Dual screen time!`}</p>
    <p>{`After a day of messing about with xorg.conf I had flawless video output on both the fancy new 17" flat screen and the 14" monitor that came with my first computer in 1995. I was `}<em parentName="p">{`so`}</em>{` proud.`}</p>
    <p>{`Sure recompiling `}<a parentName="p" {...{
        "href": "http://kde.org/",
        "title": "KDE"
      }}>{`KDE`}</a>{` with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Xinerama",
        "title": "Xinerama"
      }}>{`Xinerama`}</a>{` support took another three days (I was a Gentoo user back then), and launching a hardware accelerated game made the screens become mirrored, but it was amazeballs. I was a hacker just like in the movies! This was some 10 years ago.`}</p>
    <p>{`Ever since, I have been guarding that xorg.conf file with my life. It came with me through many linux distro changes, several monitors, and graphics cards, until a few years ago I deleted it.`}</p>
    <p>{`Ubuntu had become great enough that my painstakingly crafted configuration was no longer necessary. All I had to do was say `}<em parentName="p">{`"Yes, I have two screens"`}</em>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Linux",
        "title": "Linux"
      }}>{`Linux`}</a>{` gives me exactly what I want from dual screen support:`}</p>
    <ul>
      <li parentName="ul">{`launcher opens on screen you are currently working on`}</li>
      <li parentName="ul">{`the same top menu bar is repeated on both screens`}</li>
      <li parentName="ul">{`start menu, or dock, or whatever you call it, can be on both or just one screen depending on config`}</li>
      <li parentName="ul">{`you essentially have one big screen`}</li>
      <li parentName="ul">{`windows can be dragged seamlessly between screens`}</li>
      <li parentName="ul">{`windows can be placed across both screens`}</li>
      <li parentName="ul">{`desktop switching treats the whole workspace as a unit`}</li>
      <li parentName="ul">{`exposé feature shows windows on each screen`}</li>
      <li parentName="ul">{`dialogs open on active screen`}</li>
    </ul>
    <p>{`This was my setup before I retired the aging linux box a few weeks ago:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/41af585a415be6dff3f88518c829d8a3/21b4d/images-2950.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "35.42600896860987%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'142\\'%20viewBox=\\'0%200%20400%20142\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2020c0%2011%200%2019%201%2018%200-3%206-2%207%201H1L0%2091v51h114c113%200%20113%200%20113-2s1-2%2086-2c80%200%2086%200%2087%202%201%201%201-21%201-69V0H0v20m9%2054v67h86c84%200%2085%200%2085-2s-1-2-46-2H66V77h33l1-6v-5H66V7H9v67m221-62c0%202%200%202%205%202%204%200%206%200%207-2a624%20624%200%2001131%202h25V9H230v3m17%205l71%201%2071-1c0-2-9-2-71-2s-71%200-71%202m-17%2011l1%206h30v11h117v55h-59a252%20252%200%2001-74-3c-14%200-15%200-15%202s1%202%2084%202h84V22H230v6M0%2091l1%2029V97h3c2%200%203%200%203-2-1-2-5-3-5%200-1%201-1-4-1-10%200-8%200-11%201-10l1-2c-1-2%201-5%202-3v2c-2%200-2%200%200%202%202%201%204%200%202-2v-1l1-1c0-2-1-2-3-2-3%200-4%200-4-3%200-4%200-4%203-4l4-1H1V43h3c3%200%203%200%201-1l-4-1c-1-1-1%209-1%2050m230%2029l1%2016h167v-16c0-14%200-15-2-15H230v15\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/41af585a415be6dff3f88518c829d8a3/ca0a1/images-2950.webp 223w", "/static/41af585a415be6dff3f88518c829d8a3/75680/images-2950.webp 445w", "/static/41af585a415be6dff3f88518c829d8a3/8d1ba/images-2950.webp 890w", "/static/41af585a415be6dff3f88518c829d8a3/af3f0/images-2950.webp 1280w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/41af585a415be6dff3f88518c829d8a3/e92b6/images-2950.png 223w", "/static/41af585a415be6dff3f88518c829d8a3/e66bf/images-2950.png 445w", "/static/41af585a415be6dff3f88518c829d8a3/4ef49/images-2950.png 890w", "/static/41af585a415be6dff3f88518c829d8a3/21b4d/images-2950.png 1280w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/41af585a415be6dff3f88518c829d8a3/4ef49/images-2950.png",
                "alt": "Dual screen on Ubuntu",
                "title": "Dual screen on Ubuntu",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dual screen on Ubuntu`}</figcaption>{`
  `}</figure></p>
    <p>{`You see, I'm a programmer. I don't have a main screen and a secondary screen. I `}<em parentName="p">{`need`}</em>{` a giant workspace so I can fit all my terminals and text editors and browser windows in front of me. One terminal, one emacs, and one browser is the minimum.`}</p>
    <p>{`But usually there's two to three terminals, two browsers, two or more emacses and at least one chat program to keep in touch with the team. Before retiring my linux box I actually used the Mac as a dedicated third screen just-for-chats.`}</p>
    <h2 {...{
      "id": "enter-apple-multi-monitor"
    }}>{`Enter `}<a parentName="h2" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple's`}</a>{` `}<a parentName="h2" {...{
        "href": "http://en.wikipedia.org/wiki/Multi-monitor",
        "title": "Multi-monitor"
      }}>{`Dual Screen`}</a></h2>
    <p>{`The first time I used dual screen on a Mac was a few years ago. I was shocked and horrified.`}</p>
    <p>{`The concept of having a main and a secondary screen was paramount to the experience. One monitor was The One You Are Using. It contained the top menu bar, the dock and whenever an app opened a new window or dialog, that's where it would appear.`}</p>
    <p>{`Even Quicksilver always opened there.`}</p>
    <p>{`A few months ago I tried again and Apple had greatly improved. Sure they still thought I had a main and secondary screen and would only launch new apps on Main, but at least apps opened new windows and dialogs on the active screen.`}</p>
    <p>{`This was the old way.`}</p>
    <ul>
      <li parentName="ul">{`menu bar is on main screen`}</li>
      <li parentName="ul">{`dock is on main`}</li>
      <li parentName="ul">{`a Space (desktop) spans both screens and acts as a single workspace`}</li>
      <li parentName="ul">{`new apps only open on main screen`}</li>
      <li parentName="ul">{`disconnecting a screen causes some weirdness`}</li>
      <li parentName="ul">{`active corners are for both screens as a whole`}</li>
      <li parentName="ul">{`windows can be dragged between screens flawlessly`}</li>
      <li parentName="ul">{`windows can span both screens`}</li>
      <li parentName="ul">{`screenshots create two images - one for each screen`}</li>
    </ul>
    <p>{`The situation has improved since my first try, especially regarding app dialogs and new app windows appearing where I'm actually looking. This system worked very well.`}</p>
    <p>{`If only they fixed those issues with new apps, menu bar and the dock ...`}</p>
    <h2 {...{
      "id": "enter-os-x-mavericks"
    }}>{`Enter OS X Mavericks`}</h2>
    <p>{`Lo and behold, last night Mavericks came out with the grand promise of Apple finally fixing dual screen support. I updated instantly.`}</p>
    <p>{`Dual screen was the only thing I was excited about.`}</p>
    <p>{`Who cares about Finder tabs, I've had those on Linux and Windows since forever and never used them. Meh, folder tags are silly, and I guess the Calendar app is kinda prettier than it used to be, and the system behaves much smoother.`}</p>
    <p>{`No more glitchy desktop switching animations for the win!`}</p>
    <p>{`But damn it, Apple, we need to talk about that dual screen support. What the fuck?`}</p>
    <p>{`They fixed the only two features that bothered me - both screens are now main. New apps open on the active screen, both screens have the top menu bar and both have the dock. Perfect.`}</p>
    <p>{`But they ruined everything else.`}</p>
    <p>{`A desktop no longer spans both screens. You have to switch separately for each screen, which goes right against the idea of having one giant workspace with desktops forming project-based groups of windows.`}</p>
    <p>{`In their desire to make dual screen easier, they also made dragging windows from one screen to another feel off and windows can no longer span both screens.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/be47678de81e938bcf3255b8fca37082/aa440/images-2951.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "28.699551569506728%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'115\\'%20viewBox=\\'0%200%20400%20115\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2058v57h50a671%20671%200%200050-2c1-1%202-1%201-2l1-2c2-2%204-2%2011-3%2013%200%2016%200%2016%204%200%202%200%202%202%203l4-1%202%201c1%202%201%202%201-1l2-3c1%200%206%204%205%205l6%201%206-1%201-2%201%201c0%202%201%202%204%202s4%200%203-1l-1-2-1-1-2-1h-2c-2%203-2%201-2-7%200-4%200-4%202-3%202%203%205%203%203%200-2-2-2-3%200-3l3-4c3-5%202-7%200-11l-3-4-2-3-2-2-1-1v-4l1-7%202-6c0-3-1-24-3-30%200-2%200-2%2012-2h12v18l-1%2036v18l-2-2-2-2-1%204-3%2018c0%202%2012%202%20114%202h114V0H0v58M84%203v1l-1%205v5h8c7%200%208%200%208-2%201-2%201-1%201%201%200%206%203%201%203-6%200-4%200-5-2-5l-2%201-6%201-6-1-2-1c-2%200-2%200-1%201m135%2019l6%201h6v46l15-1c14%200%2015%200%2014%202h1l19-1h18V22l-39-1-40%201m-81%203c-2%202-3%202-47%202l-45%201a1120%201120%200%200199-2c-4%200-5%200-2-1%204%200%205-2%200-2l-5%202m205%201l-5%205-2%202h2l2%201-1%201c-4%200-5%209-1%2014%202%203%202%204-4%204-4%200-4%200-4-2%202-6%202-7-4-7-6-1-9%202-6%206%202%203%202%203-8%203h-10v50h13c11%200%2012%200%2012-2s1-2%203-2%202%200%200%201c-3%200-3%205%200%205%201%200%202-1%202-3%200-1%200-2%201-1l2%202v2l-5%202-3%201c0%201%209%202%2020%202%2014%200%2018-1%2013-5h3c3%200%204%200%206-2s3-4%201-4l-2-2c0-2%201-3%202-3s1-1-2-8c-1-2-1-3-2-2s-1%201-2-1l-2-2v2c1%203-1%203-3%200l-1-16c0-14%200-14-2-14s-2-1-2-3l-1-16c0-2%200-2-1%200h-4c-3-2-3-3%200-3s4-2%203-5c-2-3-4-2-8%200m26-1l2%201-1%201c-3-1-3%201-3%2023v22h29V24h-14c-8%200-14%200-13%201M56%2031l37%201%2036-1-36-1-37%201M46%2069v33h51l48%201-2%201h2l3-1c0-2%203-1%204%201%202%202%202%202%202-2s0-5-2-5l-1-7V35H46v34\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be47678de81e938bcf3255b8fca37082/ca0a1/images-2951.webp 223w", "/static/be47678de81e938bcf3255b8fca37082/75680/images-2951.webp 445w", "/static/be47678de81e938bcf3255b8fca37082/8d1ba/images-2951.webp 890w", "/static/be47678de81e938bcf3255b8fca37082/3838e/images-2951.webp 1335w", "/static/be47678de81e938bcf3255b8fca37082/293e0/images-2951.webp 1500w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be47678de81e938bcf3255b8fca37082/e92b6/images-2951.png 223w", "/static/be47678de81e938bcf3255b8fca37082/e66bf/images-2951.png 445w", "/static/be47678de81e938bcf3255b8fca37082/4ef49/images-2951.png 890w", "/static/be47678de81e938bcf3255b8fca37082/4e814/images-2951.png 1335w", "/static/be47678de81e938bcf3255b8fca37082/aa440/images-2951.png 1500w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/be47678de81e938bcf3255b8fca37082/4ef49/images-2951.png",
                "alt": "Dual screen exposé",
                "title": "Dual screen exposé",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dual screen exposé`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "702px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/cae8f04890a5a9d97addd3f05827ce3e/d6331/images-2952.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.668161434977584%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'150\\'%20viewBox=\\'0%200%20400%20150\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M169%203l-1%206v3H0v28h11l10-1h-1v-2l-1-2c-1%201-3-13-3-19%200-3%202-1%202%202%201%202%201%202%201-1s1-4%205-4l2%201h1l71-1h70v137h150v-45h-91v-6l1-6%2071-1h71V78l1-13%2014-1c13%200%2015%200%2015%202V0H169v3M1%2065c0%203%200%203%203%203s3%200%203%203-2%205-5%205H0v34h92V94h9V61H1v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cae8f04890a5a9d97addd3f05827ce3e/ca0a1/images-2952.webp 223w", "/static/cae8f04890a5a9d97addd3f05827ce3e/75680/images-2952.webp 445w", "/static/cae8f04890a5a9d97addd3f05827ce3e/de2ca/images-2952.webp 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cae8f04890a5a9d97addd3f05827ce3e/e92b6/images-2952.png 223w", "/static/cae8f04890a5a9d97addd3f05827ce3e/e66bf/images-2952.png 445w", "/static/cae8f04890a5a9d97addd3f05827ce3e/d6331/images-2952.png 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cae8f04890a5a9d97addd3f05827ce3e/d6331/images-2952.png",
                "alt": "Separating active and non-active screen makes sense",
                "title": "Separating active and non-active screen makes sense",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Separating active and non-active screen makes sense`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/5a6f65f2f6d68df330d529342449d784/2bef9/images-2953.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "40.80717488789237%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'163\\'%20viewBox=\\'0%200%20400%20163\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%205v5h76a1913%201913%200%2001-69%204H5l-3-1c-2%200-2%200-2%204v4h18v7H0v8h7c8%200%208%200%207%202%200%201%200%202%201%201%201-2%202-1%202%202%201%204-2%206-5%204-2-1-2-1-2%201s0%202%201%201h1l3%201c2%200%202%201%202%203l-1%203c-4-1-9%200-9%202l1%201%201-1h1l2%201h3c2%200%202%201%202%207%200%207%200%208-2%207v2h1l1%203c0%202-1%203-4%203l-3%201H7c0%202%203%202%204%201h1l1%201%202%201c3%202%203%2046%200%2048h-4c0%202%204%204%205%203l1%2014%201%2015%201-58V46h40a279%20279%200%200140%201c0-2%205-1%205%201l1%203v-3l1-2v3h6c1%202%202%202%203%200%202-1%201-2-2-2h-3c-2%200-1-1%203-1%208-1%2012%200%2012%202l1%202%201-1h1v-1c-3-2-3-2%2011-2l12%201v1l1-1%2040-1c14%200%2019%200%2018%201-3%201-2%203%200%203l2-1h2l-1-2%207-1c9-1%2014%200%2012%201v3l1%207-1%207h-1v1l1%201v9l1%2040v48h73V52l-22-1h-22v-5l47-1h48v-4c0-3%200-4%202-4l2-2c0-3%202-4%2011-4h6V15h23l-11%201h-11v15h10c10%200%2011%200%2011%202l1-15-1-15v3h-10c-9%200-10%200-11-2s-9-3-9%200c0%201-5%202-5%200-1-2-15-2-15-1%200%202-4%203-5%201%200-2-20-2-21%200l-3%201c-1%200-2%200-1-1%200-1%201-1-7-2l-7%201c0%202-5%203-5%201l-5-2c-3%200-4%200-3%201%200%202%200%202-2%202l-4-1c0-2-7-2-7%200l-2%201-3-1c0-2-6-2-7%200h-4c-1-1-3-2-7-2h-7c-1-1-3%201-2%202l-2%201-4-2c0-3-3-2-4%200%200%203-4%203-42%203h-35l-1-3-1-3h-19c-11%200-18%201-18%202%200%203-2%204-13%204L99%205l2-3%201-2H0v5m202%203l-30%201%202%202h2a1214%201214%200%200056-2l-30-1m-58%207h-3c-2%200-2%200-1%201%201%202%202%202%204%202h2c-1%201%200%201%202%201l4%201%207%201c5%200%207%200%205-1-2%200-3-1-3-2s-1-2-6-3h-11M52%2026l1%204h180v-7H52v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5a6f65f2f6d68df330d529342449d784/ca0a1/images-2953.webp 223w", "/static/5a6f65f2f6d68df330d529342449d784/75680/images-2953.webp 445w", "/static/5a6f65f2f6d68df330d529342449d784/8d1ba/images-2953.webp 890w", "/static/5a6f65f2f6d68df330d529342449d784/a9a89/images-2953.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5a6f65f2f6d68df330d529342449d784/e92b6/images-2953.png 223w", "/static/5a6f65f2f6d68df330d529342449d784/e66bf/images-2953.png 445w", "/static/5a6f65f2f6d68df330d529342449d784/4ef49/images-2953.png 890w", "/static/5a6f65f2f6d68df330d529342449d784/2bef9/images-2953.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5a6f65f2f6d68df330d529342449d784/4ef49/images-2953.png",
                "alt": "Dragging window, stage 1",
                "title": "Dragging window, stage 1",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dragging window, stage 1`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7e89b37f4c32dc45da6c19f86ee52886/2bef9/images-2954.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.95067264573991%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'227\\'%20viewBox=\\'0%200%20400%20227\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M205%204v4h-43a246%20246%200%2001-65-4c-1-1-1%200-1%201l-2%202V6l-1-1c-1%200-2%200-1%201l-2%201-2-2-3-2-5-1c-3-1-5-1-8%201-2%201-3%203-2%203L48%207C26%207%2025%207%2026%205c0-2-1-3-3-1h-1c0-1-1-1-2%201-2%202-4%202-11%202-9%200-9%200-9%203v2h22a703%20703%200%200167%201c9%200%2010%200%2010%202s0%202-3%201c-2-2-3-2-3-1s-1%202-2%201c-4%200-4%200-1-1%201-1%201-1-1-1l-2%201-15%201c-13%200-14%200-15%202v2l-1-2c-1-3-18-3-19%200v2l-2-2c-2-3-18-3-19%200v2l-2-2c-1-2-2-2-8-2s-6%200-6%203c0%202%200%202%202%201h1l-1%202c-1%200-2%201-2%203s0%202%205%202h4v4c0%204-1%205-5%205H0v10h31v10h69v64c0%2070%200%2066%206%2043l4-13c3-5%205-15%205-23l1-9a170%20170%200%20000-35c-2%200-2-1-2-3l1-3v-2l-1-7-2-9v-3h55v3l1%203v-6h54c51%200%2055%200%2055%202h1c0-2%201-2%2015-2%2013%200%2015%200%2014%202l1%201%201-1c0-1%209-2%2045-2h46V0H205v4m-2%206l-51%201-26%201%203%201%202%201h-7c-2%201%200%202%203%202%202%200%203%200%202%201l-1%201h1c3-2%2012%201%2012%205h-11a952%20952%200%200088-1v-1c-2-2-3-1-2%201%200%202%200%202-2%201s-2-1-1-3v-2c1-2-2-3-5-2-2%200-3%200-4-4l-1-2m64%208h-8c-3%200-3%202%200%202%203%201%203%202%200%204-2%201-1%201%206%201%209%200%2011-1%2011-6-1-3-6-4-9-1m53%200h-7c-1-1-8-1-8%201%202%203%202%205%201%205h-4c-2%201%200%201%207%201l9-1%201-1%201%201c-1%201%201%201%204%201%207%200%207%200%206-5%200-3-1-3-5-3l-5%201m38-1l-1%201-3%201c-3%200-3%200-1-1s2-1-1-1c-5%201-6%202-4%204h4c1%201%201%201-6%203-4%201-3%201%206%201s11%200%2010-2l1-3c1-1%201-1-3-1-2%200-2%200-1-1%202-1%201-2-1-1M112%2027c-2%200-2%201-1%204h1c1-1%201-1%201%201l-2%201-1%201c0%202%2010%202%20138%202h132v-4l-1-4c-2-1-264-2-267-1m-12%20180l1%2020h7c8%200%209%200%204-9-3-6-8-12-10-12l-1-10-1%2011\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7e89b37f4c32dc45da6c19f86ee52886/ca0a1/images-2954.webp 223w", "/static/7e89b37f4c32dc45da6c19f86ee52886/75680/images-2954.webp 445w", "/static/7e89b37f4c32dc45da6c19f86ee52886/8d1ba/images-2954.webp 890w", "/static/7e89b37f4c32dc45da6c19f86ee52886/a9a89/images-2954.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7e89b37f4c32dc45da6c19f86ee52886/e92b6/images-2954.png 223w", "/static/7e89b37f4c32dc45da6c19f86ee52886/e66bf/images-2954.png 445w", "/static/7e89b37f4c32dc45da6c19f86ee52886/4ef49/images-2954.png 890w", "/static/7e89b37f4c32dc45da6c19f86ee52886/2bef9/images-2954.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7e89b37f4c32dc45da6c19f86ee52886/4ef49/images-2954.png",
                "alt": "Dragging window, stage 2",
                "title": "Dragging window, stage 2",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dragging window, stage 2`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f259aeb122ccd08d2ea9fa11e9a3079d/2bef9/images-2955.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.946188340807176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'175\\'%20viewBox=\\'0%200%20400%20175\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%204v5h112v9h-8c-7%200-7%200-8-3s-2-3-8-3l-7%201H65l-7-1-7%201h-1c-2-2-13-1-14%201h-1c0-2-1-2-7-2l-7%201h-1l-8-1-6%201H5c-3-2-5-1-5%203v4h23l23%201v5H0v8h9l9%201h-3l-1%201c2%202%206%201%206%200-1-2%200-2%202-2%201%200%202%200%201%202h1l1-1c-1-2%206-1%207%201h3l-2-1c-1-1%2016-1%2038-1%2040%200%2040%200%2039-4l9-1h9v-7l-1%203v-3c0-5%200-6-1-3v-4l1-7%2031-1h31l1%202v5c-1%202%200%202%2057%202l59%201v6H189v15h21l21%201h1l69-1h68v-3c0-3%200-4%202-4s2%201%202%2072a2610%202610%200%20001%2056v-16h3l2-1-2-1h-3v-13c0-11%201-13%202-14v-2c-2%200-3-9-1-12v-2a203%20203%200%20010-45l2-6c2-2%202-2-1-2-1-1-2-1-1-2V30l-1-2c-1-1%204-1%2012-1h14v3l1-8-1-9c0%204-2%204-2%200l2-4%201-5c0-3%200-4-1-2v3h-37l-36-1-1-2c-2-1-7%200-7%202h-4c-2-2-15-3-15-1h-5c-1-1-18-2-19%200-1%201-5%202-5%200%201-1%200-1-6-1l-6%201-2%201-3-1-4-1-4%201-2%201-3-1c0-1-6-2-7%200h-4c-1-1-6-2-7%200%200%201-4%202-4%200%200-1-14-2-15-1-2%203-5%203-5%201%200-3-2-3-4-1l-3%202-2%201h-61c-7%200-8%200-8-3l-1-2h-18C85%200%2084%201%2084%203s-1%202-11%202H63l2-2%201-3H0v4m112%20101v70h77v-8l1-4v-1l-1-26-1-20-1%203c0-2-4-4-5-3h-2l-2-1-4-1-1-1h-7c1%201%200%202-1%202l-1-1c0-2%200-2-3-1l-5%202c-1%200-2%200-1%201l-1%201-2-1h-1c-1%201-2%200-4-2-3-2-3-2-4-1-1%202-2%202-3%201h-2l-1-1v-11l-1-2-1-2-2-1%201-1%201-2c0-2%200-2-1%200l-2%203v-3l1-3v-3l-1-2c-1%201-2-1-2-3l-1-11c-2-8-2-9-1-24%200-8%201-10%202-11l18-1%2017-1c1-1-9-1-26-1h-27v71\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f259aeb122ccd08d2ea9fa11e9a3079d/ca0a1/images-2955.webp 223w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/75680/images-2955.webp 445w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/8d1ba/images-2955.webp 890w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/a9a89/images-2955.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f259aeb122ccd08d2ea9fa11e9a3079d/e92b6/images-2955.png 223w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/e66bf/images-2955.png 445w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/4ef49/images-2955.png 890w", "/static/f259aeb122ccd08d2ea9fa11e9a3079d/2bef9/images-2955.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f259aeb122ccd08d2ea9fa11e9a3079d/4ef49/images-2955.png",
                "alt": "Dragging window, stage 3",
                "title": "Dragging window, stage 3",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dragging window, stage 3`}</figcaption>{`
  `}</figure></p>
    <p>{`As you can see, dragging a window between screens reinforces the idea that both screens are separate entities. The part of the window where you're holding it with the mouse, is active, the other vanishes as soon as you let go.`}</p>
    <p>{`In short, this is how dual screen works now:`}</p>
    <ul>
      <li parentName="ul">{`both screens are main`}</li>
      <li parentName="ul">{`menu bar on both, dock on both`}</li>
      <li parentName="ul">{`launching apps works the way you expect`}</li>
      <li parentName="ul">{`dialogs and new windows open where you want`}</li>
      <li parentName="ul">{`two screens are no longer a cohesive unit`}</li>
      <li parentName="ul">{`windows can't span screens`}</li>
      <li parentName="ul">{`windows try too hard to show the transition between screens`}</li>
      <li parentName="ul">{`you have to switch each screen's desktop separately`}</li>
      <li parentName="ul">{`active corners on both screens`}</li>
      <li parentName="ul">{`exposé and such affect both screens at once`}</li>
      <li parentName="ul">{`disconnecting a screen doesn't cause weirdness`}</li>
    </ul>
    <p>{`There is an option on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mission_Control_%28OS_X%29",
        "title": "Mission Control (OS X)"
      }}>{`Mission Control`}</a>{` settings to turn off separate desktops for each screen, but that also turns off the new features I do like.`}</p>
    <p>{`Apple's new dual screen support is a mixed bag of good and bad. Ideally we could have features from both worlds, but maybe they intend to fix this soon? I sure hope so.`}</p>
    <p>{`I'm giving the new way a few more days and if I can't get used to it, I'm switching back to the hell of having a secondary and a main screen.`}</p>
    <p>{`But at least Mavericks fixed the bug that disconnected wi-fi every time my screen went to sleep.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b0d29892-45bc-407b-b9cb-2a3f0fabda6f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      